import script from "./churuku.vue?vue&type=script&setup=true&lang=js"
export * from "./churuku.vue?vue&type=script&setup=true&lang=js"

import "./churuku.vue?vue&type=style&index=0&id=12bb4408&scoped=true&lang=scss"

import exportComponent from "D:\\liu\\jmzc\\jimuERPVUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12bb4408"]])

export default __exports__